module.exports = "/assets/data/45570aed860e7b9a48652212ff3c31cb-NN2.data.json";